namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_app_fullscreen, {

		position: 'fixed',
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		zIndex: 6,
		background: {
			color: $mol_theme.back,
		},
		
	} )
	
}
